import { Link, Outlet } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { LanguageMenu } from './LanguageMenu'
import { useUiStore } from '../lib/uiStore'
import { useSession } from '../lib/useSession'
import { logout } from '../lib/api'

export function ShellLayout() {
  const { t } = useTranslation()
  const theme = useUiStore((s) => s.theme)
  const setTheme = useUiStore((s) => s.setTheme)
  const { isAuthenticated, user } = useSession()

  return (
    <div className="shell">
      <header className="shell-header">
        <Link to="/welcome" className="brand">
          <span className="brand-mark" aria-hidden />
          <span className="brand-name">7GC Mail</span>
        </Link>
        <div className="shell-actions">
          {isAuthenticated ? (
            <span className="shell-user muted" title={user?.email || ''}>
              {t('shell.signedIn')}: {user?.email || '—'}
            </span>
          ) : null}
          <LanguageMenu />
          <label className="theme-label">
            <span className="visually-hidden">{t('shell.theme')}</span>
            <select
              value={theme}
              onChange={(e) => setTheme(e.target.value as 'light' | 'dark' | 'system')}
              aria-label={t('shell.theme')}
            >
              <option value="system">{t('shell.themeSystem')}</option>
              <option value="light">{t('shell.themeLight')}</option>
              <option value="dark">{t('shell.themeDark')}</option>
            </select>
          </label>
          {isAuthenticated ? (
            <button
              type="button"
              className="btn btn-ghost"
              onClick={() => {
                void logout().then(() => window.location.assign('/welcome'))
              }}
            >
              {t('auth.logout')}
            </button>
          ) : null}
        </div>
      </header>
      <main className="shell-main">
        <Outlet />
      </main>
    </div>
  )
}
